import {
  Box,
  Divider,
  Grid,
  GridColumn,
  ThemeOverride
} from "@modernatx-internal/component-library";
import React from "react";

export interface AtlasFooterBlockProps {
  links?: React.ReactNode[];
  disclaimer?: React.ReactNode;
  labels?: React.ReactNode[];
}

const LinkDivider = () => (
  <Box sx={{ height: 4, display: ["none", "flex", "flex"], alignItems: "center" }}>
    <Divider color="white" direction="vertical" thickness="sm" />
  </Box>
);

const MobileDivider = () => (
  <Box sx={{ display: ["block", "none", "none"], width: 10 }}>
    <Divider color="white" thickness="sm" />
  </Box>
);

const FooterRow = ({ items }: { items: React.ReactNode[] }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: ["column", "row", "row"],
      alignItems: ["flex-start", "center", "center"],
      flexWrap: "wrap",
      gap: [3, 4, 5]
    }}
  >
    {items.map((item, index) => (
      <React.Fragment key={index}>
        {item}
        {index !== items.length - 1 && <LinkDivider />}
      </React.Fragment>
    ))}
  </Box>
);

export const AtlasFooter: React.FC<AtlasFooterBlockProps> = ({ links, disclaimer, labels }) => {
  const hasLinks = !!links && links.length > 0;
  const hasDisclaimer = !!disclaimer;
  const hasLabels = !!labels && labels.length > 0;
  const showMobileDivider = hasLinks && (hasDisclaimer || hasLabels);

  return (
    <ThemeOverride mode="dark">
      <Box
        as="footer"
        sx={{
          backgroundColor: "color-current-brand-950",
          py: 8
        }}
      >
        <Grid>
          <GridColumn
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 4,
              "& a span, & button span": {
                color: "white"
              }
            }}
          >
            {hasLinks && <FooterRow items={links} />}
            {showMobileDivider && <MobileDivider />}
            {hasDisclaimer && disclaimer}
            {hasLabels && <FooterRow items={labels} />}
          </GridColumn>
        </Grid>
      </Box>
    </ThemeOverride>
  );
};
